<script>
    import { useNavigate, useLocation } from "svelte-navigator";
    import { oidcToken } from "./stores";
  
    const navigate = useNavigate();
    const location = useLocation();
  
    $: if (!$oidcToken) {
      navigate("/login", {
        state: { from: $location.pathname },
        replace: true,
      });
    }
  </script>
  
  {#if $oidcToken}
    <slot />
  {/if}
  